// extracted by mini-css-extract-plugin
export default {"productCarousel":"bl","twoColumns":"cl","subhed":"el","promo":"fl","questionIcon":"gl","thumbContainer":"hl","carousel":"il","tape":"jl","flexContainer":"kl","nav":"ll","body":"ml","reviews":"nl","header":"ol","hed":"pl","priceContainer":"ql","oldPrice":"rl","newPrice":"sl","infoTabs":"tl","tabs":"ul","text":"vl","questionWrapper":"wl","isQuantity":"xl","title":"yl","titleRight":"zl","addToCart":"Al","servingsPerItem":"Bl","quantityInput":"Cl","quantityButton":"El","takeTheQuiz":"Fl"};
    if(module.hot) {
      // 1714654863473
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  